export default __webpack_public_path__ + "static/media/CafeSign400.320f1077.jpg";